import React from 'react';
import { STATS } from '../constants/data';
import styles from './StatsBand.module.css';

export default function StatsBand() {
  return (
    <div className={styles.band}>
      {STATS.map((s, i) => (
        <div key={i} className={styles.item}>
          <div className={styles.value}>{s.value}</div>
          <div className={styles.label}>{s.label}</div>
        </div>
      ))}
    </div>
  );
}
